/**
 * RastreamentoHistorico
 * @author Simpli CLI generator
 */
import {$, Helper, Request, Resource} from 'simpli-web-sdk'
import {ResponseSerialize} from 'simpli-web-sdk'
import {Rastreamento} from '@/model/resource/Rastreamento'
import {RastreamentoHistoricoCollection} from '@/model/collection/RastreamentoHistoricoCollection'

/* TODO: review generated class */
export class RastreamentoHistorico extends Resource {
  idRastreamentoHistoricoPk: number = 0

  @ResponseSerialize(Rastreamento)
  rastreamento: Rastreamento | null = null

  latitude: number | null = null
  longitude: number | null = null
  dataPosicao: string | null = null

  statusCarga: string | null = null
  idExterno: string | null = null

  get $id() {
    return this.idRastreamentoHistoricoPk
  }
  set $id(val) {
    this.idRastreamentoHistoricoPk = val
  }

  get idRastreamentoFk() {
    if (!this.rastreamento) return 0
    return this.rastreamento.$id
  }
  set idRastreamentoFk(val) {
    if (!this.rastreamento) this.rastreamento = new Rastreamento()
    this.rastreamento.$id = val
  }

  /**
   * Gets a instance of a given ID of RastreamentoHistorico
   */
  async getRastreamentoHistorico(id: number) {
    return await Request.get(`/admin/rastreamento-historico/${id}`)
      .name('getRastreamentoHistorico')
      .as(this)
      .getData()
  }

  /**
   * Lists the instances of RastreamentoHistorico
   */
  static async listRastreamentoHistorico(params: any) {
    return await Request.get(`/admin/rastreamento-historico`, {params})
      .name('listRastreamentoHistorico')
      .as(RastreamentoHistoricoCollection)
      .getData()
  }

  /**
   * Persists a new instance of RastreamentoHistorico. Use ID = 0 to create a new one,
   * or ID > 0 to update a current one
   */
  async persistRastreamentoHistorico() {
    return await Request.post(`/admin/rastreamento-historico`, this)
      .name('persistRastreamentoHistorico')
      .asNumber()
      .getData()
  }

  /**
   * Lists the instances of RastreamentoHistorico to use it in a CSV file
   */
  static async listCsvRastreamentoHistorico(params: any) {
    return await Request.get(`/admin/rastreamento-historico/csv`, {params})
      .name('listCsvRastreamentoHistorico')
      .as(RastreamentoHistoricoCollection)
      .getData()
  }
}
